import React, { Component } from 'react'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import ThumbnailAdminComponent from './ThumbnailAdminComponent'

const T = {
  bg: '#f1f5f9', card: '#ffffff', border: '#e8edf5',
  blue: '#3b82f6', blueD: '#2563eb', navy: '#0f172a',
  txt: '#1e293b', txt2: '#64748b', muted: '#94a3b8',
  green: '#16a34a', greenBg: '#f0fdf4', greenBdr: '#bbf7d0',
  red: '#dc2626', redBg: '#fef2f2', redBdr: '#fecaca',
  warn: '#f59e0b', warnBg: '#fffbeb', warnBdr: '#fde68a',
  r: 16, rsm: 10,
  shadow: '0 1px 3px rgba(15,23,42,.06)',
  shadowMd: '0 4px 16px rgba(15,23,42,.08)',
  font: "'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"
}

const S = {
  page: { background: T.bg, minHeight: '100vh', fontFamily: T.font, color: T.txt },
  header: {
    background: T.card, borderBottom: `1px solid ${T.border}`,
    padding: '20px 32px', display: 'flex', alignItems: 'center',
    gap: 12, position: 'sticky', top: 0, zIndex: 10, boxShadow: T.shadow
  },
  btnBack: {
    background: 'none', border: `1px solid ${T.border}`, borderRadius: T.rsm,
    padding: '8px 14px', cursor: 'pointer', color: T.txt2,
    fontSize: 14, display: 'flex', alignItems: 'center', gap: 6
  },
  btnPrimary: {
    background: T.blue, border: 'none', borderRadius: T.rsm,
    padding: '10px 20px', cursor: 'pointer', color: '#fff',
    fontSize: 14, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6,
    marginLeft: 'auto'
  },
  btnPrimaryDisabled: {
    background: T.muted, border: 'none', borderRadius: T.rsm,
    padding: '10px 20px', cursor: 'not-allowed', color: '#fff',
    fontSize: 14, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6,
    marginLeft: 'auto', opacity: .6
  },
  title: { fontSize: 22, fontWeight: 700, color: T.navy, margin: 0 },
  content: { maxWidth: 900, margin: '0 auto', padding: '28px 24px' },
  card: {
    background: T.card, borderRadius: T.r, border: `1px solid ${T.border}`,
    boxShadow: T.shadow, marginBottom: 20, overflow: 'hidden'
  },
  cardHeader: {
    padding: '16px 24px', borderBottom: `1px solid ${T.border}`,
    display: 'flex', alignItems: 'center', justifyContent: 'space-between'
  },
  cardTitle: { fontSize: 14, fontWeight: 600, color: T.txt2, textTransform: 'uppercase', letterSpacing: '.06em' },
  cardBody: { padding: '24px' },
  label: { fontSize: 11, fontWeight: 600, color: T.muted, textTransform: 'uppercase', letterSpacing: '.07em', marginBottom: 6, display: 'block' },
  uploadZone: {
    border: `2px dashed ${T.border}`, borderRadius: T.r,
    padding: '24px', textAlign: 'center', cursor: 'pointer',
    background: '#f8fafc', transition: 'border-color .15s, background .15s'
  },
  uploadZoneActive: {
    border: `2px dashed ${T.blue}`, borderRadius: T.r,
    padding: '24px', textAlign: 'center', cursor: 'pointer',
    background: '#eff6ff'
  },
  fileInput: { display: 'none' },
  uploadIcon: { fontSize: 32, marginBottom: 8 },
  uploadText: { fontSize: 14, color: T.txt2, marginBottom: 4 },
  uploadHint: { fontSize: 12, color: T.muted },
  coverPreview: {
    borderRadius: T.rsm, overflow: 'hidden', background: '#f8fafc',
    width: '100%', maxWidth: 320, aspectRatio: '4/3',
    border: `1px solid ${T.border}`, position: 'relative'
  },
  coverImg: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' },
  coverPlaceholder: {
    width: '100%', aspectRatio: '4/3', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', gap: 8, color: T.muted,
    background: '#f8fafc', border: `2px dashed ${T.border}`, borderRadius: T.rsm
  },
  photoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
    gap: 12
  },
  alertWarn: {
    background: T.warnBg, border: `1px solid ${T.warnBdr}`, borderRadius: T.rsm,
    padding: '10px 14px', color: T.warn, fontSize: 13, fontWeight: 500,
    display: 'flex', alignItems: 'center', gap: 8, marginTop: 10
  },
  spinner: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '60px 0', flexDirection: 'column', gap: 12
  },
  counter: {
    display: 'inline-flex', alignItems: 'center',
    background: '#eff6ff', border: `1px solid #bfdbfe`,
    borderRadius: 20, padding: '2px 10px', fontSize: 12, fontWeight: 600, color: T.blue
  },
}

class GaleriaDomicilioFormularioComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      id: this.props.match.params.id,
      portadaFile: null,
      portadaData: '',
      fotografiasGalleryFileArray: [],
      fotografiasGalleryDataArray: [],
      loading: false,
      saving: false,
      dragOverPortada: false,
      dragOverGallery: false,
    }
    this.portadaInputRef = React.createRef()
    this.galleryInputRef = React.createRef()
  }

  componentDidMount() {
    const { id } = this.state
    if (Number(id) === -1) return

    this.setState({ loading: true })
    ElementsDataService.retrieveElement('domicilios/galeria', id)
      .then(response => {
        const imageCount = response.data?.imageCount
        if (!imageCount) { this.setState({ loading: false }); return }

        this.setState({ imageCount })

        const promises = []

        if (imageCount > 0) {
          promises.push(
            ElementsDataService.getImageFile(`?fileName=Domicilios/domicilio_${id}/galeria/0.jpg`)
              .then(r => this.setState({ portadaFile: r, portadaData: URL.createObjectURL(r) }))
          )
        }

        for (let i = 1; i < imageCount; i++) {
          const idx = i
          promises.push(
            ElementsDataService.getImageFile(`?fileName=Domicilios/domicilio_${id}/galeria/${idx}.jpg`)
              .then(r => {
                const files = [...this.state.fotografiasGalleryFileArray]
                const datas = [...this.state.fotografiasGalleryDataArray]
                files[idx - 1] = r
                datas[idx - 1] = URL.createObjectURL(r)
                this.setState({ fotografiasGalleryFileArray: files, fotografiasGalleryDataArray: datas })
              })
          )
        }

        Promise.all(promises).then(() => this.setState({ loading: false }))
      })
      .catch(() => this.setState({ loading: false }))
  }

  onSubmit = () => {
    const { portadaFile, fotografiasGalleryFileArray, id } = this.state

    if (!portadaFile) {
      this.setState({ errorMsg: 'Debes tener al menos una fotografía de fachada.' })
      return
    }

    this.setState({ saving: true, errorMsg: '' })

    const formData = new FormData()
    formData.append('galleryFiles', portadaFile)
    fotografiasGalleryFileArray.forEach(f => formData.append('galleryFiles', f))

    ElementsDataService.createElement(`domicilios/galeria/${id}`, formData)
      .then(() => {
        this.setState({ saving: false })
        this.props.history.push(`/domicilios/reportes/${id}`)
      })
      .catch(() => this.setState({ saving: false, errorMsg: 'Error al guardar la galería. Intenta de nuevo.' }))
  }

  onFilePortadaChange = (e) => {
    const file = e.target.files[0]
    if (!file) return
    this.setState({ portadaFile: file, portadaData: URL.createObjectURL(file), errorMsg: '' })
  }

  onGalleryFilesChange = (e) => {
    const newFiles = Array.from(e.target.files)
    this.addGalleryFiles(newFiles)
  }

  addGalleryFiles = (newFiles) => {
    const combined = [...this.state.fotografiasGalleryFileArray, ...newFiles]
    const datas = combined.map(f => URL.createObjectURL(f))
    this.setState({ fotografiasGalleryFileArray: combined, fotografiasGalleryDataArray: datas })
  }

  portadaDeleteHandler = () => {
    // Fachada es obligatoria — mostrar advertencia
    this.setState({ warnPortada: true })
    setTimeout(() => this.setState({ warnPortada: false }), 3000)
  }

  deleteHandler = (index) => {
    const files = [...this.state.fotografiasGalleryFileArray]
    files.splice(index, 1)
    const datas = files.map(f => URL.createObjectURL(f))
    this.setState({ fotografiasGalleryFileArray: files, fotografiasGalleryDataArray: datas })
  }

  handleDrop = (e, type) => {
    e.preventDefault()
    const files = Array.from(e.dataTransfer.files).filter(f => f.type.startsWith('image/'))
    if (type === 'portada' && files[0]) {
      this.setState({ portadaFile: files[0], portadaData: URL.createObjectURL(files[0]), dragOverPortada: false })
    } else if (type === 'gallery' && files.length) {
      this.setState({ dragOverGallery: false })
      this.addGalleryFiles(files)
    }
  }

  render() {
    const {
      portadaData, fotografiasGalleryDataArray,
      loading, saving, dragOverPortada, dragOverGallery,
      errorMsg, warnPortada
    } = this.state

    const totalFotos = (portadaData ? 1 : 0) + fotografiasGalleryDataArray.length

    return (
      <div style={S.page}>
        {/* Header */}
        <div style={S.header}>
          <button style={S.btnBack} onClick={() => this.props.history.push(`/domicilios/reportes/${this.state.id}`)}>
            ‹ Volver al Reporte
          </button>
          <div style={S.title}>Editar Galería</div>
          {totalFotos > 0 && <span style={S.counter}>{totalFotos} foto{totalFotos !== 1 ? 's' : ''}</span>}
          <button
            style={saving ? S.btnPrimaryDisabled : S.btnPrimary}
            onClick={this.onSubmit}
            disabled={saving}
          >
            {saving
              ? <><span style={{ display: 'inline-block', width: 14, height: 14, border: '2px solid rgba(255,255,255,.4)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin .8s linear infinite' }} /> Guardando...</>
              : '✓ Guardar Galería'
            }
          </button>
          <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
        </div>

        <div style={S.content}>
          {errorMsg && (
            <div style={{ ...S.alertWarn, background: T.redBg, border: `1px solid ${T.redBdr}`, color: T.red, marginBottom: 16 }}>
              ⚠️ {errorMsg}
            </div>
          )}

          {loading ? (
            <div style={S.spinner}>
              <div style={{ width: 36, height: 36, border: `3px solid ${T.border}`, borderTopColor: T.blue, borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
              <span style={{ color: T.txt2, fontSize: 14 }}>Cargando galería...</span>
            </div>
          ) : (<>

            {/* Fachada */}
            <div style={S.card}>
              <div style={S.cardHeader}>
                <span style={S.cardTitle}>📷 Fotografía de Fachada</span>
                <span style={{ fontSize: 12, color: T.muted }}>Obligatoria · Se muestra como portada</span>
              </div>
              <div style={S.cardBody}>
                <div style={{ display: 'flex', gap: 24, alignItems: 'flex-start', flexWrap: 'wrap' }}>

                  {/* Preview */}
                  <div>
                    {portadaData
                      ? <div style={S.coverPreview}>
                          <img src={portadaData} alt="Fachada" style={S.coverImg} />
                        </div>
                      : <div style={S.coverPlaceholder}>
                          <span style={{ fontSize: 40 }}>🏠</span>
                          <span style={{ fontSize: 13 }}>Sin fachada</span>
                        </div>
                    }
                    {warnPortada && (
                      <div style={S.alertWarn}>⚠ Siempre debe haber una fachada</div>
                    )}
                  </div>

                  {/* Upload zone */}
                  <div style={{ flex: 1, minWidth: 200 }}>
                    <input ref={this.portadaInputRef} type="file" accept="image/*" style={S.fileInput}
                      onChange={this.onFilePortadaChange} />
                    <div
                      style={dragOverPortada ? S.uploadZoneActive : S.uploadZone}
                      onClick={() => this.portadaInputRef.current.click()}
                      onDragOver={e => { e.preventDefault(); this.setState({ dragOverPortada: true }) }}
                      onDragLeave={() => this.setState({ dragOverPortada: false })}
                      onDrop={e => this.handleDrop(e, 'portada')}
                    >
                      <div style={S.uploadIcon}>📁</div>
                      <div style={S.uploadText}>{portadaData ? 'Cambiar fotografía de fachada' : 'Seleccionar fotografía de fachada'}</div>
                      <div style={S.uploadHint}>Haz clic o arrastra una imagen aquí · JPG, PNG</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Galería de Interiores */}
            <div style={S.card}>
              <div style={S.cardHeader}>
                <span style={S.cardTitle}>🖼 Fotografías de Interiores</span>
                <span style={S.counter}>{fotografiasGalleryDataArray.length} foto{fotografiasGalleryDataArray.length !== 1 ? 's' : ''}</span>
              </div>
              <div style={S.cardBody}>

                {/* Upload zone */}
                <input ref={this.galleryInputRef} type="file" accept="image/*" multiple style={S.fileInput}
                  onChange={this.onGalleryFilesChange} />
                <div
                  style={{ ...(dragOverGallery ? S.uploadZoneActive : S.uploadZone), marginBottom: 20 }}
                  onClick={() => this.galleryInputRef.current.click()}
                  onDragOver={e => { e.preventDefault(); this.setState({ dragOverGallery: true }) }}
                  onDragLeave={() => this.setState({ dragOverGallery: false })}
                  onDrop={e => this.handleDrop(e, 'gallery')}
                >
                  <div style={S.uploadIcon}>📁</div>
                  <div style={S.uploadText}>Agregar fotografías de interiores</div>
                  <div style={S.uploadHint}>Puedes seleccionar múltiples imágenes · Haz clic o arrastra aquí</div>
                </div>

                {/* Grid de fotos */}
                {fotografiasGalleryDataArray.length > 0
                  ? <div style={S.photoGrid}>
                      {fotografiasGalleryDataArray.map((img, idx) => (
                        <ThumbnailAdminComponent
                          key={idx}
                          index={idx}
                          deleteHandler={this.deleteHandler}
                          img={img}
                        />
                      ))}
                    </div>
                  : <div style={{ textAlign: 'center', color: T.muted, fontSize: 14, padding: '16px 0' }}>
                      Sin fotografías de interiores aún
                    </div>
                }
              </div>
            </div>

            {/* Botón Guardar (bottom) */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
              <button style={S.btnBack} onClick={() => this.props.history.push(`/domicilios/reportes/${this.state.id}`)}>
                Cancelar
              </button>
              <button
                style={saving ? S.btnPrimaryDisabled : S.btnPrimary}
                onClick={this.onSubmit}
                disabled={saving}
              >
                {saving ? 'Guardando...' : '✓ Guardar Galería'}
              </button>
            </div>

          </>)}
        </div>
      </div>
    )
  }
}

export default GaleriaDomicilioFormularioComponent
